module.exports = __webpack_public_path__ + "media/dobry_wzor/polub-nas-img-1fa76e15.png";